/** Sets the browser tab title. React hoists <title> into <head>. */
export function DocumentTitle({
  children,
  product = 'Runqo Console',
}: {
  children?: string;
  product?: string;
}) {
  return <title>{children ? `${children} · ${product}` : product}</title>;
}
